<template>
    <div>
        <ul class="pagination">
            <div class="pagination-item">
                <li class="pagination-item" style="margin-right: 5px" v-if="!isInFirstPage && currentPage != 2">
                    <button type="button" @click="onClickFirstPage()" >
                        1
                    </button>
                </li>
            </div>

            <li v-for="(page, i) in pages" :key="i" class="pagination-item" >
                <button type="button" @click="onClickPage(page.name)" :disabled="page.isDisabled" :class="{ active: isPageActive(page.name) }" >
                    {{ page.name }}
                </button>
            </li>
            
            <div class="pagination-item">
                <li class="pagination-item last-item" style="margin-left: 5px" v-if="!isInLastPage && currentPage != totalPages - 1 && maxVisibleButtons < totalPages">
                    <button type="button" @click="onClickLastPage()">
                        {{ totalPages }}
                    </button>
                </li>
            </div>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 3
        },
        totalPages: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true,
        },
        buttons: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        startPage() {
            if (this.currentPage === 1) {
                return 1;
            }
            // if (this.currentPage === this.totalPages) {
            //     return this.totalPages - this.maxVisibleButtons;
            // }
            return this.currentPage - 1;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.endPage;
        },
        endPage() {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },
        pages() {
            const range = [];

            for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage 
                });
            }

            return range;
        }
        
    },
    methods: {
        onClickFirstPage() {
            this.$emit('pagechanged', 1);
        },
        onClickPreviousPage() {
            this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
            this.$emit('pagechanged', page);
        },
        onClickNextPage() {
            this.$emit('pagechanged', this.currentPage + 1);
        },
        onClickLastPage() {
            this.$emit('pagechanged', this.totalPages);
        },
        isPageActive(page) {
            return this.currentPage === page;
        }
    }
}
        
</script>

<style scoped>
    .pagination {
        list-style-type: none;
    }

    .pagination-item {
        display: inline-block;
    }

    .active {
        background-color: #4D76C8;
        color: #ffffff;
        padding: 5px 10px;
    }

    button {
        padding: 3px 8px;
        border: none;
        border-radius: 3px;
        margin: 3px;
        background: #73777B;
        color: white;
        font-size: 1.1em;
        cursor: pointer;
    }

    button:focus {
        outline-style: none;
    }
</style>
